export default {};

// solr config
const SOLR_TEST_DATA_ON_PRODUCTION = false; // do not set this to true
const SOLR_TEST_DATA_ON_STAGING = true; // do not set this to false
const SOLR_TEST_DATA_ON_DEVELOPMENT = true; // do not set this to false
const SOLR_PRODUCTION_URL = 'https://www.messe-stuttgart.de/solr';
const SOLR_TEST_URL = 'https://test.messe-stuttgart.de/solr';
const MKDB_TEST_URL = 'https://mkdb2-staging.messe-stuttgart.de';
const MKDB_PRODUCTION_URL = 'https://mkdb2.messe-stuttgart.de';
export const SOLR_TEST_DATA = process.env.NODE_ENV === 'production' ? SOLR_TEST_DATA_ON_PRODUCTION : process.env.NODE_ENV === 'staging' ? SOLR_TEST_DATA_ON_STAGING : SOLR_TEST_DATA_ON_DEVELOPMENT; // eslint-disable-line no-nested-ternary
export const SOLR_VERSION = 'v1.0';
export const SOLR_URL = SOLR_TEST_DATA ? SOLR_TEST_URL : SOLR_PRODUCTION_URL;
export const MKDB_URL = SOLR_TEST_DATA ? MKDB_TEST_URL : MKDB_PRODUCTION_URL;
